import * as React from "react";
import {
  TableHead,
  TableRow,
  TableCell,
  TableSortLabel,
  Box,
} from "@mui/material";
import { visuallyHidden } from "@mui/utils";
import { useTranslation } from "react-i18next";

export type Order = "asc" | "desc";

interface HeadCell {
  id: string;
  label: string;
  numeric: boolean;
}

interface EnhancedTableProps {
  onRequestSort: (event: React.MouseEvent<unknown>, property: string) => void;
  order: Order;
  orderBy: string;
  rowCount: number;
}

export default function EnhancedTableHead(props: EnhancedTableProps) {
  const { order, orderBy, onRequestSort } = props;
  const { t } = useTranslation();

  const headCells: readonly HeadCell[] = [
    {
      id: "firstName",
      numeric: false,
      label: t("common.firstName"),
    },
    {
      id: "lastName",
      numeric: false,
      label: t("common.lastName"),
    },
    {
      id: "phone",
      numeric: false,
      label: t("common.phone"),
    },
    {
      id: "email",
      numeric: false,
      label: t("users.colEmail"),
    },
    {
      id: "gender",
      numeric: false,
      label: t("users.colGender"),
    },
    {
      id: "active",
      numeric: false,
      label: t("common.status"),
    },
    {
      id: "createdAt",
      numeric: false,
      label: t("users.colRegistered"),
    },
  ];
  const createSortHandler =
    (property: string) => (event: React.MouseEvent<unknown>) => {
      onRequestSort(event, property);
    };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
            padding="normal"
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              <span className="font-bold">{headCell.label}</span>
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc"
                    ? t("common.sortedDescending")
                    : t("common.sortedAscending")}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
        <TableCell align="center">
          <span className="font-bold">{t("common.actions")}</span>
        </TableCell>
      </TableRow>
    </TableHead>
  );
}
